<template>

    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange" @groupupdate="groupup">
        <Cquiz :navsub="navsub" :options="c_myoption" v-if="isload" :grouplist="grouplist"></Cquiz>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'myquiz',
        mixins: [mixinmember],
        components: {
            Cquiz: () => import('@/components/Cquiz')
        },
        data() {
            return {
                curnavkv: 30
            };
        },
        computed: {
            c_options: function () {
                let _options = {
                    'hasoption': true, 'courselev': 2, 'showcourse': 2, 'haskw': true, 'noteng': 1, 'issch': 0
                };
                switch (this.navsub) {
                    case 0:
                        _options.showcourse = 0;
                        _options.haskw = false;
                        break;
                    case 1:
                        _options.showcourse = 2;
                        break;
                }
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 3;
                _myoption.isdone = this.navsub;
                return _myoption;
            }
        }
    }
</script>
